export const constants = {
    BASE_URL: '/ddd-be',

    BLACK_COLOR: 'rgb(0,0,0)',
    GREY_COLOR: 'rgba(0,0,0,0.5)',
    LIGHT_GREY_COLOR: 'rgb(236,236,236)',
    LIGHT_LIGHT_GREY_COLOR: 'rgb(248,248,248)',
    RED_COLOR: 'rgb(212,5,17)',
    YELLOW_COLOR: 'rgb(255,204,0)',
    WHITE_COLOR: 'rgb(255,255,255)'
} as const;